import { DICT_LANGUAGE, LANGUAGE } from 'src/utils/constant'
import api from '../../api/index.api'
import DictTypes from '../dict/dict.types'
import DefinitionTypes from './definition.types'
import { getEmptyDef, normalizeAdminDictLookupResponse } from './definition.utils'

export const onGetDefinition = (payload, fCallBack) => {
	return async (dispatch, getState) => {
		const { word, isForce, isDisableLoading } = payload
		console.log('1.1 word**** ', payload)
		if (word) {
			try {
				const currentDef = getState().definition
				const currentTerm = currentDef.term

				// if existed and not empty
				console.log(
					'here*********** ',
					currentTerm,
					word,
					currentDef[LANGUAGE.VI],
					isForce || currentTerm !== word || !currentDef[LANGUAGE.VI]
				)
				if (
					isForce ||
					currentTerm !== word ||
					!currentDef[LANGUAGE.VI] // check if empty base on any lang
				) {
					if (!isDisableLoading) {
						dispatch(onSetDefinitionLoading())
					}
					const result = await api.dictWordApi.lookup({
						word: word,
					})

					if (result) {
						const {
							vi,
							en,
							dictWord: normalizedDictWord,
						} = normalizeAdminDictLookupResponse(result)

						const definitionVN = vi
						const definitionEN = en

						const rs = {
							[DICT_LANGUAGE.VI]: definitionVN,
							[DICT_LANGUAGE.EN]: definitionEN,
							dictWord: normalizedDictWord,
							term: definitionEN?.word || definitionVN?.word,
							spelling:
								definitionVN?.spelling ||
								definitionVN?.spelling,
							spellingUk: definitionVN?.spellingUk,
						}

						if (fCallBack) {
							fCallBack(true, rs)
						}
						dispatch(setDefinition(rs))
					} else {
						const rs = setDefinition(getEmptyDef(word))
						if (fCallBack) {
							fCallBack(true, rs)
						}
						dispatch(rs)
					}
				} else {
					const rs = setDefinition(currentDef)
					if (fCallBack) {
						fCallBack(true, rs)
					}
					dispatch(rs)
				}
			} catch (err) {
				console.log(err)
				dispatch(setDefinition(getEmptyDef(word)))

				if (fCallBack) {
					fCallBack(false, err.message)
				}
			}
		} else {
			const rs = getEmptyDef(word)

			dispatch(setDefinition(rs))
		}
	}
}
export const onGetDefinitionVi = (payload, fCallBack) => {
	return async () => {
		try {
			const rs = await api.lookupWordApi.getVietnameseDefinitionPublicly(
				payload
			)

			if (fCallBack) {
				fCallBack(true, rs)
			}
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

export const onSetTerm = payload => ({
	type: DefinitionTypes.SET_TERM,
	payload,
})

export const onSetDefinitionLoading = () => ({
	type: DefinitionTypes.SET_DEFINITION_LOADING,
})

export const onResetDefinition = word => ({
	type: DefinitionTypes.RESET_DEFINITION,
	payload: word,
})

export const onReloadDefinitionWithoutLoading = (_, fCallBack) => {
	return async (dispatch, getState) => {
		try {
			const currentDef = getState().definition
			const currentTerm = currentDef.term
			// reload def
			dispatch(
				onGetDefinition(
					{
						word: currentTerm,
						isForce: true,
						isDisableLoading: true,
					},
					fCallBack
				)
			)
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

export const setDefinition = payload => ({
	type: DefinitionTypes.SET_DEFINITION,
	payload,
})

export const setWordType = payload => ({
	type: DefinitionTypes.SET_WORD_TYPE,
	payload,
})
// word

export const onUpdateDictWord = (data, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordApi.update(data)

			dispatch({
				type: DefinitionTypes.UPDATE_DICT_WORD_IN_DETAIL,
				payload: data,
			})

			dispatch({
				type: DictTypes.UPDATE_DICT_WORD,
				payload: data,
			})
			fCallBack && fCallBack(true, data)
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

// meaning
export const onCreateMeaning = (payload, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordMeaningApi.create(payload)

			dispatch(onReloadDefinitionWithoutLoading(null, fCallBack))
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

export const onUpdateMeaning = (payload, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordMeaningApi.update(payload)

			dispatch(onReloadDefinitionWithoutLoading(null, fCallBack))
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}
export const onDeleteMeaning = (payload, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordMeaningApi.remove(payload)

			dispatch(onReloadDefinitionWithoutLoading(null, fCallBack))
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

// example
export const onCreateDictWordExample = (payload, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordExampleApi.create(payload)

			dispatch(onReloadDefinitionWithoutLoading(null, fCallBack))
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

export const onUpdateDictWordExample = (payload, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordExampleApi.update(payload)

			dispatch(onReloadDefinitionWithoutLoading(null, fCallBack))
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

export const onDeleteDictWordExample = (payload, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordExampleApi.remove(payload)

			dispatch(onReloadDefinitionWithoutLoading(null, fCallBack))
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}
